export default __webpack_public_path__ + "static/media/1847.84cd98ec.png";